import { getRuleErrorMessage, URLRegex } from "@/utils/formHelper";
import { QRPdfForm } from "@/data/types/qrForms";
import { qrNameValidation } from "./shared";
import { TFunction } from "i18next";

export const pdfValidation = (data: QRPdfForm, t: TFunction) => {
  return [
    qrNameValidation(t),
    {
      name: "companyName",
      rules: {
        maxLength: {
          value: 100,
          message: getRuleErrorMessage("companyName", "maxLength", data),
        },
      },
    },
    {
      name: "pdfName",
      rules: {
        maxLength: {
          value: 100,
          message: getRuleErrorMessage("pdfName", "maxLength", data),
        },
      },
    },
    {
      name: "pdfDescription",
      rules: {
        maxLength: {
          value: 100,
          message: getRuleErrorMessage("pdfDescription", "maxLength", data),
        },
      },
    },
    {
      name: "websiteUrl",
      rules: {
        pattern: {
          value: new RegExp(URLRegex),
          message: getRuleErrorMessage("websiteUrl", "pattern", data),
        },
      },
    },
  ];
};
